import { Component } from '@angular/core';

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrl: './mobile-header.component.scss',
  standalone: false
})
export class MobileHeaderComponent {

  onStoreClicked() {
    window.open('https://saraplus.myspreadshop.com/', '_blank')
  }

  onFaqClicked() {
    console.log('live support clicked')
  }

  onLoginClicked() {
    window.open('https://www.saraplus.com/e/servicepages/login.aspx', '_blank')
  }

  
}
